<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}
        </template>
        <template slot="input">
            <div class="input-container">
                <input :value="selectedValuesString" :class="{ 'input-component': true, 'active': active}"
                       @input="handleInput" @click="showSelection" ref="inputComponent"/>
                <div class="selection-container" ref="selectionContainer" v-show="selectionOpen">
                    <div class="selection-buttons">
                        <simple-button @press="clearSelected">Clear</simple-button>
                        <simple-button @press="hideSelection">OK</simple-button>
                        <input v-model="namesFilter" :class="{ 'input-component': true, 'active': active}"/>
                    </div>
                    <div :class="{ 'selection-option': true, 'selected': selectedOptions.find(opt => opt == option.id) } "
                         v-for="option in filteredOptions" @click="selectOption(option)">
                        <div class="selection-option-check">
                            <icon :icon="['fal', 'check']" v-if="selectedOptions.find(opt => opt == option.id)"/>
                        </div>
                        <div class="selection-option-name">
                            {{option.name}}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputLayout from "../form/FormInputLayout";
    import SwitchButton from "../button/SwitchButton";
    import SimpleButton from "../button/SimpleButton";

    export default {
        name: "FormMultiSelectInput",
        components: {SimpleButton, SwitchButton, FormInputLayout},
        props: {
            helpItemCode: String,
            disabled: Boolean,
            caption: String,
            options: Array,
            value: Array
        },
        data: function () {
            return {
                selectionOpen: false,
                namesFilter: "",
                stringValue: "",
                active: false,
                selectedOptions: [],
            }
        },
        computed: {
            filteredOptions() {
                return this.options.filter(opt => opt.name.toLowerCase().includes(this.namesFilter.toLowerCase()));
            },
            selectedValuesString() {
                return this.options.filter(opt => this.selectedOptions.includes(opt.id)).sort((optA, optB) => optA.name.localeCompare(optB.name)).map(opt => opt.name).join(", ");
            }
        },
        methods: {
            handleInput() {
                this.$emit('input', this.selectedOptions);
            },
            selectOption(option) {
                let alreadySelected = this.selectedOptions.find(opt => opt == option.id);
                if (alreadySelected != undefined) {
                    this.selectedOptions.splice(this.selectedOptions.indexOf(alreadySelected), 1);
                } else {
                    this.selectedOptions.push(option.id)
                }
                this.handleInput();
            },
            clearSelected() {
                this.selectedOptions.splice(0, this.selectedOptions.length);
            },
            showSelection() {
                this.selectionOpen = true;
                let container = this.$refs.selectionContainer;
                let inputComponent = this.$refs.inputComponent;
                let closeListener = function (e) {
                    if (!container.contains(e.target)) {
                        this.hideSelection();
                        document.removeEventListener('mouseup', closeListener);
                    }

                }.bind(this);
                document.addEventListener('mouseup', closeListener);
                container.style.width = inputComponent.offsetWidth + "px";
                container.style.left = inputComponent.offsetLeft + "px";
                container.style.top = (inputComponent.offsetTop + inputComponent.offsetHeight) + "px";
            },
            hideSelection() {
                this.selectionOpen = false;
            }
        },
        watch: {
            value: {
                handler(newVal, oldVal) {
                    if(newVal !== undefined) {
                        this.selectedOptions = newVal
                    }
                    else {
                        this.selectedOptions = []
                    }
                },
                immediate: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/global";

    .input-container {
        display: flex;
        flex-flow: row;
        white-space: nowrap;
    }


    .input-component {
        border: none;
        border-bottom: 1px solid var(--input-border-color);
        background-color: var(--input-background-color);
        color: var(--input-font-color);
        padding: 2px 10px 2px 10px;
        outline: none;
        width: 100%;
        font-family: Source Sans Pro;
        font-size: $inputFontSize;
    }

    .active {
        color: var(--input-active-font-color);
        background-color: var(--input-active-background-color);
        border: 1px solid var(--input-active-border-color);
    }

    .required {
        color: var(--accent-color);
    }

    .selection-container {
        position: absolute;
        background-color: var(--input-background-color);
        top: 27px;
        left: 23px;
        width: 50px;
        min-height: 80px;
        z-index: 9999;
        overflow-x: hidden;
        border-left: 1px solid var(--input-border-color);
        border-right: 1px solid var(--input-border-color);
        border-bottom: 1px solid var(--input-border-color);
    }

    .selection-option {
        padding: 2px;
        color: var(--input-font-color);
        display: flex;
        flex-flow: row;
    }

    .selection-option:hover {
        background-color: var(--accent-color);
        color: var(--input-active-font-color);
        cursor: pointer;

    }

    .selected > .selection-option-check {
        background-color: var(--accent-color);
        color: var(--input-active-font-color)
    }

    .selection-option-check {
        width: 15px;
        padding: 0px 2px 0px 2px;
    }

    .selection-option-name {
        padding: 0px 0px 0px 2px;
    }

    .selection-buttons {
        width: 100%;
        display: flex;
        flex-flow: row;
        justify-items: end;
        background-color: var(--input-border-color);
    }

    .selection-buttons > * {
        margin: 2px;
    }
</style>